import React from "react";
import { connect } from "react-redux";
import { Translate, withLocalize } from "react-localize-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import { searchActions } from "../../../store/searchStore";
import CrossIcon from "../../../img/icons/Cross";

import "./chartLegend.scss";
import { legendItems } from "./data";

function ChartLegend(props) {
  return (
    <article className="panel">
      <div className="panel-heading">
        <div className="panel-heading-title">
          <div
            style={{
              marginRight: "auto",
              marginTop: "auto",
              marginBottom: "auto",
            }}
          >
            <Translate id="Report.Legend.Title" />
          </div>
          <CrossIcon
            className="icon-centered"
            onClick={props.closePanel}
            style={{ marginLeft: ".5em" }}
          />
        </div>
      </div>
      <div className="legend-container">
        <ul className="legend-list-1">
          {legendItems.map((legend) => (
            <li className="legend-item-1">
              <h3 className="legend-title">{legend.title}</h3>
              <ul className="legend-list">
                {legend.items.map((item) => (
                  <>
                    <li className="legend-item">
                      <div className="wrapper">
                        {item.icon && item.icon}
                        {item.separator && <p>|</p>}
                        {item.color != null && (
                          <span
                            className="clr-box"
                            style={{ backgroundColor: item.color }}
                          ></span>
                        )}
                      </div>
                      <p className="legend-text">{item.description}</p>
                    </li>
                  </>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
}

export default withRouter(
  withLocalize(
    connect(
      (state) => ({ ...state.search }),
      (dispatch) => bindActionCreators({ ...searchActions }, dispatch)
    )(ChartLegend)
  )
);
